/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */


import React from "react";

export const ContactTitle: React.FC = () => {
    return (
        <>
            <p className="jc-txt-heading fs-3 mb-4">Contact us</p>
            <p className="jc-txt-body fs-6 mb-4">Send us a message.</p>
        </>
    );
}